// Strava granted only public activities (ATL-173). The connect path says so
// with ?scope=public on Connected sources; a Strava sign-in lands on the
// dashboard instead (?strava_scope=public), so the hint is kept here until
// the card can show it. Cleared by a full-permission connect. Per browser
// only: losing it costs a hint, never data.

const KEY = "atlas-strava-public-only";

export function rememberStravaPublicOnly(): void {
  try {
    window.localStorage.setItem(KEY, "1");
  } catch {
    // Private mode or blocked storage: the hint is a nicety.
  }
}

export function forgetStravaPublicOnly(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
}

export function hasStravaPublicOnlyHint(): boolean {
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}
